import React from "react";
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import "./Capabilities.css";
import obstetrics from "../../practices_images/Obstetrics.jpg"; // Ensure this path is correct
import CollapsibleSection from "./CollapsibleSection"; // adjust path if needed

const Obstetrics = () => {
  return (
  <motion.div
    variants={pageVariants}
    initial="initial"
    animate="animate"
    exit="exit"
  >
      <div className="cap-container">
        <h1>Obstetrics and Gynecology</h1>

        <div className="cap-section">
          <div className="text-content">
            {/* ✅ First 2 sections: normal (always visible) */}
            <h3>Supporting care across every stage of women’s health</h3>
            <p>
              Obstetrics and gynecology practices support patients across a wide range of clinical needs, from routine preventive care to pregnancy, delivery, and complex gynecologic procedures. Care delivery requires continuity, coordination, and precise documentation across multiple phases of care.
            </p>
            <p>
              We partner with obstetrics and gynecology practices to help them operate with clarity, reliability, and confidence.
            </p>
  
            <h3>The Care Environment</h3>
            <p>
              OB and gynecology practices manage diverse care pathways that involve ongoing monitoring, diagnostic testing, procedures, and coordination across care teams. Documentation and billing must remain accurate across both outpatient and inpatient settings, while compliance requirements and payer expectations continue to evolve.
            <p>
            </p>
              These demands create operational complexity that must be managed without disrupting patient care.
            </p>
  
            {/* ✅ Everything after: collapsible */}
            <CollapsibleSection title="Our Role">
              <p>
                We help obstetrics and gynecology practices strengthen the operational and financial processes that support comprehensive women’s health services.
              </p>
              <p>
                Our work focuses on reinforcing documentation and coding accuracy, supporting reliable billing and reimbursement processes, improving financial visibility, and aligning workflows across clinical and administrative teams.
              </p>
              <p>
                Our approach reflects the continuity and complexity inherent in women’s health care delivery.
              </p>
            </CollapsibleSection>
  
            <CollapsibleSection title="Enabling Continuity and Stability">
              <p>
                Our goal is to help practices operate with consistency and control across all stages of care.
              </p>
              <p>
                By reducing administrative burden and improving financial clarity, we support smoother coordination, stronger compliance, and more predictable performance. This allows care teams to remain focused on patients while leadership maintains operational oversight.
              </p>
            </CollapsibleSection>
  
            <CollapsibleSection title="Looking Ahead">
              <p>
                As women’s health care continues to evolve, strong operational foundations remain essential.
              </p>
              <p>
                We work with practices to build the structure and discipline required to support patients over long term relationships and critical moments of care.
              </p>
              <p>
                Let’s begin a conversation about how your practice can move forward with clarity and purpose.
              </p>
            </CollapsibleSection>
          </div>

          {/* Image Section */}
          <div className="image-container">
            <img src={obstetrics} alt="Obstetrics" />
          </div>

        </div>
      </div>
    </motion.div>
  );
};

export default Obstetrics;
